import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  Container,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Tabs,
  Tab,
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Collapse,
  useMediaQuery,
  MenuItem,
  TextField,
  Select,
  Backdrop,
  CircularProgress,
  InputAdornment,
  Checkbox,
  ListItemText,
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import ChevronLeftOutlined from "@mui/icons-material/ChevronLeftOutlined";
import Menu from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ConfirmModal from "../../../components/ConfirmModal";
import MenuComponent from "../../../components/MenuComponent";
import {
  convertTimestampToDate,
  hazardRequestFields,
  incidentRequestFields,
  accidentRequestFields,
  getAddress,
} from "../../../services/helper";
import routes from "../../../routes";
import nucleusxp from "nucleusxp";
import SnackbarAlert from "../../../components/SnackbarAlert";
import AnalyticsModal from "../../../components/Director/AnalyticsModal";
import Filter from "../../../components/Filter";
const HealthAndSafetyReview = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [selectedOption, setSelectedOption] = useState("hazard");
  const [submittedReportsTab, setSubmittedReportsTab] = useState("Pending");
  const [insightsTab, setInsightsTab] = useState("hazards");
  const [submittedReportsExpanded, setSubmittedReportsExpanded] =
    useState(false);
  const [insightsExpanded, setInsightsExpanded] = useState(false);
  const [createReportExpanded, setCreateReportExpanded] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState({});
  const [statusFilter, setStatusFilter] = useState([]);
  const [statusSubmitFilter, setStatusSubmitFilter] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showFilters, setShowFilters] = useState(false); // New state to control filter visibility
  const [showSubmitFilters, setShowSubmitFilters] = useState(false);
  const [showSubmitSearch, setShowSubmitSearch] = useState(false);
  const [searchSubmitQuery, setSearchSubmitQuery] = useState("");
  const [showInsightSearch, setShowInsightSearch] = useState(false);
  const [searchInsightQuery, setSearchInsightQuery] = useState("");
  const [hazards, setHazards] = useState([]);
  const [incidents, setIncidents] = useState([]);
  const [accidents, setAccidents] = useState([]);
  const [drafts, setDrafts] = useState([]);
  const [pendings, setPendings] = useState([]);
  const [queried, setQueried] = useState([]);
  const [apporved, setApproved] = useState([]);
  const [loading, setLoading] = useState(false);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [wholeReports, setWholeReports] = useState([]);
  const [analyticsData, setAnalyticsData] = useState();
  const [openAnalyticsModal, setOpenAnalyticsModal] = useState(false);
  const [filterState, setFilterState] = useState({
    isFilter: false,
    type: "",
    datasets: {},
  });
  const [filters, setFilters] = useState({
    submit: [],
    insight: [],
    startDate: "",
    endDate: "",
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });
  const handleFilterToggle = () => {
    // setShowFilters((prev) => !prev); // Toggle the visibility of filters
    setFilterState((prev) => ({
      ...prev,
      isFilter: true,
      type: "insight",
      datasets: {
        approved: apporved.length,
        queried: queried.length,
        pendings: pendings.length,
      },
    }));
  };

  const handleSubmitFilterToggle = () => {
    // setShowSubmitFilters((prev) => !prev);
    setFilterState((prev) => ({
      ...prev,
      isFilter: true,
      type: "submit",
      datasets: {
        hazards: hazards.length,
        incidents: incidents.length,
        accidents: accidents.length,
      },
    }));
  };
  useEffect(() => {
    const fetchReports = async () => {
      try {
        setLoading(true);
        const response = await nucleusxp.healthSafety.getReports();
        const response_hazards = await nucleusxp.healthSafety.getHazards();
        const response_reportedBy = await nucleusxp.healthSafety.getEmployees();
        const response_managers =
          await nucleusxp.healthSafety.getManagerReports();
        localStorage.setItem(
          "hazards",
          JSON.stringify(response_hazards.items ?? []),
        );
        localStorage.setItem(
          "reportedBy",
          JSON.stringify(response_reportedBy.items ?? []),
        );
        const reports = response?.items || [];
        setWholeReports(reports);
        const mananger_reports = response_managers?.items || [];
        const hazards = mananger_reports.filter(
          (item) => item.reportType === "hazard" && !item.isDraft,
        );
        const incidents = mananger_reports.filter(
          (item) => item.reportType === "incident" && !item.isDraft,
        );
        const accidents = mananger_reports.filter(
          (item) => item.reportType === "accident" && !item.isDraft,
        );
        const drafts = reports.filter((item) => item.status === "Draft");
        const approved = reports.filter((item) => item.status === "Approved");

        const pendings = reports.filter((item) => item.status === "Pending");
        const querieds = reports.filter((item) => item.status === "Queried");

        setHazards(hazards);
        setIncidents(incidents);
        setAccidents(accidents);
        setDrafts(drafts);
        setLoading(false);
        setApproved(approved);
        setQueried(querieds);
        setPendings(pendings);
      } catch (error) {
        console.error("Failed to fetch health safety reports:", error);
        setSnackbar({
          open: true,
          severity: "error",
          message: `Please check connection with server`,
        });
        setLoading(false);
      }
    };

    fetchReports();
    if (state && state.openInsight) {
      setInsightsExpanded(true);
    }
    if (state && state.openReport) {
      setSubmittedReportsExpanded(true);
    }
  }, [state]);

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen); // Toggle Drawer visibility
  };

  const handleCreateReport = () => {
    navigate(routes.healthSafetyCreate.path, {
      state: { reportType: selectedOption, type: selectedOption },
    });
  };

  const handleSubmittedReportsTabChange = (event, newValue) => {
    setSubmittedReportsTab(newValue);
  };

  const handleInsightsTabChange = (event, newValue) => {
    setInsightsTab(newValue);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setConfirmModal(false);
    try {
      nucleusxp.healthSafety.patchReport(selectedEdit.id, {
        ...selectedEdit,
        isDraft: false,
      });
    } catch (e) {
      setSnackbar({
        open: true,
        severity: "error",
        message: `Please check connection with server`,
      });
    }
  };

  const reports = useMemo(() => {
    if (submittedReportsTab === "Pending") {
      return pendings;
    } else if (submittedReportsTab === "Queried") {
      return queried;
    } else if (submittedReportsTab === "Draft") {
      return drafts;
    } else {
      return [];
    }
  }, [submittedReportsTab, pendings, queried, drafts]);

  const insights = useMemo(() => {
    if (insightsTab === "hazards") {
      return hazards;
    } else if (insightsTab === "incidents") {
      return incidents;
    } else if (insightsTab === "accidents") {
      return accidents;
    } else {
      return [];
    }
  }, [insightsTab, hazards, incidents, accidents]);

  const filteredReports = useMemo(() => {
    return reports.filter((report) => {
      const statusMatch =
        filters.submit.length > 0
          ? filters.submit.includes(report.reportType)
          : true;
      const searchMatch =
        searchSubmitQuery.trim().length > 0
          ? report.description
              .toLowerCase()
              .includes(searchSubmitQuery.toLowerCase())
          : true;
      return statusMatch && searchMatch;
    });
  }, [filters.submit, reports, searchSubmitQuery]);

  const filteredInsights = useMemo(() => {
    return insights.filter((insight) => {
      const statusMatch =
        filters.insight.length > 0
          ? filters.insight.includes(insight.status)
          : true;
      const dateMatch =
        (!filters.startDate ||
          new Date(insight.incidentAt) >= new Date(filters.startDate)) &&
        (!filters.endDate ||
          new Date(insight.incidentAt) <= new Date(filters.endDate));
      const searchMatch =
        searchInsightQuery.trim().length > 0
          ? insight.description
              .toLowerCase()
              .includes(searchInsightQuery.toLowerCase())
          : true;
      return statusMatch && dateMatch && searchMatch;
    });
  }, [
    filters.insight,
    filters.startDate,
    filters.endDate,
    insights,
    searchInsightQuery,
  ]);

  const getStatusStyles = (status) => {
    switch (status) {
      case "Approved":
        return {
          display: "block",
          width: "60px",
          textAlign: "center",
          fontSize: "14px",
          border: "2px solid #4BB543",
          backgroundColor: "rgba(75, 182, 67, 0.14)",
          color: "#4BB543",
          padding: "4px 8px",
          borderRadius: "4px",
        };
      case "Pending":
        return {
          display: "block",
          width: "60px",
          textAlign: "center",
          fontSize: "14px",
          border: "2px solid #FFB700",
          backgroundColor: "rgba(255, 183, 0, 0.14)",
          color: "#FFB700",
          padding: "4px 8px",
          borderRadius: "4px",
        };
      case "Queried":
        return {
          display: "block",
          width: "60px",
          textAlign: "center",
          fontSize: "14px",
          border: "2px solid #9CBDFF",
          backgroundColor: "rgba(155, 189, 255, 0.14)",
          color: "#9CBDFF",
          padding: "4px 8px",
          borderRadius: "4px",
        };
      case "Rejected":
        return {
          display: "block",
          width: "60px",
          textAlign: "center",
          fontSize: "14px",
          border: "2px solid #F82323",
          backgroundColor: "rgba(248, 35, 35, 0.14)",
          color: "#F82323",
          padding: "4px 8px",
          borderRadius: "4px",
        };
      case "Draft":
        return {
          display: "block",
          width: "60px",
          textAlign: "center",
          fontSize: "14px",
          border: "2px solid #230CE5CC",
          backgroundColor: "rgba(35, 12, 229, 0.14)",
          color: "#230CE5CC",
          padding: "4px 8px",
          borderRadius: "4px",
        };
      default:
        return {};
    }
  };

  const isNonMobile = useMediaQuery("(min-width:600px)");

  const handleReportsPending = () => {
    setSubmittedReportsExpanded(!submittedReportsExpanded);
    setSubmittedReportsTab("Pending");
  };

  const handleReportsQueried = () => {
    setSubmittedReportsExpanded(!submittedReportsExpanded);
    setSubmittedReportsTab("Queried");
  };

  const handleReportsDraft = () => {
    setSubmittedReportsExpanded(!submittedReportsExpanded);
    setSubmittedReportsTab("Draft");
  };

  const handleInsightsHazards = () => {
    setInsightsExpanded(!insightsExpanded);
    setInsightsTab("hazards");
  };

  const handleInsightsIncidents = () => {
    setInsightsExpanded(!insightsExpanded);
    setInsightsTab("incidents");
  };

  const handleInsightsAccidents = () => {
    setInsightsExpanded(!insightsExpanded);
    setInsightsTab("accidents");
  };

  const handleCancel = () => {};

  const handleItemEdit = async (report, fromInsight) => {
    try {
      setSummaryLoading(true);
      const response = !fromInsight
        ? await nucleusxp.healthSafety.getReport(report.id)
        : await nucleusxp.healthSafety.getManagerReport(report.id);
      const reportData = response.item;
      const attachedFile = reportData?.files;

      const geolocation =
        reportData.geolocation &&
        typeof reportData.geolocation.lat === "number" &&
        typeof reportData.geolocation.lng === "number"
          ? await getAddress(reportData.geolocation)
          : `${reportData?.location?.addressLine1 || ""}, ${reportData?.location?.state || ""}, ${reportData?.location?.postcode || ""}`;
      setSelectedEdit((prev) => ({
        ...prev,
        id: reportData?.id ?? "",
        categoryType: reportData?.hazard ?? "",
        description: reportData?.description ?? "",
        otherType: reportData?.otherType ?? "",
        sendLocation: geolocation,
        reportedBy: reportData?.reportedBy ?? 0,
        dateOfObservation: reportData?.incidentAt ?? "",
        individuals: reportData?.individualsAffected ?? [],
        equipmentList: reportData?.equipmentAffected ?? [],
        materialList: reportData?.materialAffected ?? [],
        risk: reportData?.risk ?? "",
        priority: reportData?.priority ?? "",
        attachedFile,
        date: reportData?.updatedAt ?? "",
        otherReporter: reportData?.reportedOther ?? "",
        firstLine: reportData?.location?.addressLine1 ?? "",
        secondLine: reportData?.location?.addressLine2 ?? "",
        province: reportData?.location?.state ?? "",
        postcode: reportData?.location?.postcode ?? "",
        additionalComments: reportData?.comments ?? "",
        type: reportData?.reportType,
        reportType: reportData?.reportType,
        status: reportData?.status,
        managerNotes: reportData?.managerNotes,
        fromInsight: fromInsight,
      }));
      setSummaryLoading(false);
      setConfirmModal(true);
    } catch (e) {
      setSummaryLoading(false);
      console.log(e);
    }
  };
  const handleEdit = (field, value) => {
    if (value !== undefined) {
      navigate(routes.healthSafetyCreate.path, {
        state: {
          fromInsight: selectedEdit.fromInsight,
          id: selectedEdit.id,
          highlighted: field,
        },
      });
    } else {
      navigate(routes.healthSafetyCreate.path, {
        state: {
          fromInsight: selectedEdit.fromInsight,
          id: selectedEdit.id,
        },
      });
    }
  };

  const handleAnalytics = () => {
    const analyticsData = {
      pending: wholeReports.filter((item) => item.status === "Pending").length,
      escalated: wholeReports.filter((item) => item.status === "Approved")
        .length,
      noActionReq: wholeReports.filter((item) => item.status === "Rejected")
        .length,
      queried: wholeReports.filter((item) => item.status === "Queried").length,
      draft: wholeReports.filter((item) => item.status === "Draft").length,
    };
    setAnalyticsData(analyticsData);
    setOpenAnalyticsModal(true);
  };

  return (
    <>
      {!filterState.isFilter ? (
        <Container
          maxWidth="xs"
          sx={{
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#ecf0f7",
          }}
        >
          <Box
            sx={{
              height: "129px",
              backgroundColor: "#1C1468",
              color: "white",
              display: "flex",
              alignItems: "center",
              marginLeft: "-24px",
              marginRight: "-24px",
              zIndex: 3,
              justifyContent: "space-between",
              position: "fixed",
              width: isNonMobile ? "444px" : "calc(100vw + 10px)",
            }}
          >
            <IconButton
              edge="start"
              sx={{ marginLeft: "10px" }}
              color="inherit"
              onClick={() => navigate("/")}
            >
              <ChevronLeftOutlined />
            </IconButton>

            <Typography
              sx={{ fontSize: "16px" }}
              variant="h5"
              fontWeight="bold"
            >
              Health & Safety
            </Typography>

            <IconButton
              edge="end"
              color="inherit"
              sx={{ marginRight: "15px" }}
              onClick={handleDrawerToggle}
            >
              <Menu />
            </IconButton>
            <MenuComponent
              open={drawerOpen} // Drawer visibility
              onClose={handleDrawerToggle} // Handler to close the drawer
            />
          </Box>

          <Paper
            sx={{
              backgroundColor: "#fff",
              padding: 3,
              marginTop: "159px",
              cursor: "pointer",
            }}
            onClick={() => setCreateReportExpanded(!createReportExpanded)}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{ display: "flex", alignItems: "center" }}
            >
              Create New Report
              <IconButton
                onClick={() => setCreateReportExpanded(!createReportExpanded)}
                sx={{ marginLeft: "auto" }}
              >
                {createReportExpanded ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Typography>

            <Collapse
              in={createReportExpanded}
              onClick={(e) => e.stopPropagation()}
            >
              <RadioGroup value={selectedOption} onChange={handleChange}>
                <Grid container spacing={2} sx={{ marginTop: 2 }}>
                  <Grid item xs={12}>
                    <FormControlLabel
                      value="hazard"
                      control={<Radio />}
                      label="Hazard (hazard to avoid)"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      value="incident"
                      control={<Radio />}
                      label="Incident or near miss - no injury, no damage"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      value="accident"
                      control={<Radio />}
                      label="Accident (event - injury or damage)"
                    />
                  </Grid>
                </Grid>
              </RadioGroup>
              <Button
                onClick={handleCreateReport}
                variant="outlined"
                fullWidth
                sx={{
                  marginTop: "30px",
                  color: "#2d3648",
                  border: "2px solid #2d3648",
                  textTransform: "capitalize",
                  fontWeight: "700",
                  height: "60px",
                  padding: "0 20px",
                }}
              >
                Create Report &gt;
              </Button>
            </Collapse>
          </Paper>

          <Box sx={{ height: "20px" }} />

          <Paper
            sx={{ backgroundColor: "#fff", padding: 3, cursor: "pointer" }}
            onClick={() =>
              setSubmittedReportsExpanded(!submittedReportsExpanded)
            }
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                marginBottom: "30px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <Avatar
                src="avatar.jpg"
                sx={{ width: 30, height: 30, marginRight: "8px" }}
              />
              Submitted Reports
              <IconButton
                onClick={() =>
                  setSubmittedReportsExpanded(!submittedReportsExpanded)
                }
                sx={{ marginLeft: "auto" }}
              >
                {submittedReportsExpanded ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Typography>

            <Collapse in={!submittedReportsExpanded}>
              <Box onClick={(e) => e.stopPropagation()}>
                {!loading ? (
                  <Typography
                    variant="body1"
                    sx={{
                      display: "flex",
                      gap: 2,
                      color: "#333",
                      fontWeight: 400,
                    }}
                  >
                    <span
                      style={{
                        color: "#777",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevents the parent click event
                        handleReportsPending();
                      }}
                    >
                      Pending:{" "}
                      <strong style={{ color: "#0056b3" }}>
                        {pendings.length}
                      </strong>
                    </span>
                    <span
                      style={{
                        color: "#777",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevents the parent click event
                        handleReportsQueried();
                      }}
                    >
                      Queried:{" "}
                      <strong style={{ color: "#28a745" }}>
                        {queried.length}
                      </strong>
                    </span>

                    <span
                      style={{
                        color: "#777",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevents the parent click event
                        handleReportsDraft();
                      }}
                    >
                      Drafts:{" "}
                      <strong style={{ color: "#ffc107" }}>
                        {drafts.length}
                      </strong>
                    </span>
                  </Typography>
                ) : (
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={loading}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
                )}
              </Box>
            </Collapse>
            {submittedReportsExpanded && (
              <Box sx={{ display: "flex", flexDirection: "row", padding: 1 }}>
                <Box sx={{ textAlign: "right", width: "100%", mt: "-9" }}>
                  Filter&nbsp;{" "}
                  <IconButton
                    sx={{
                      border: "1px solid #CAD3E7",
                      borderRadius: "4px",
                      backgroundColor: "#f3f6f9",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSubmitFilterToggle();
                    }}
                    aria-label="toggle filters"
                  >
                    {/* Use your custom filter icon here */}
                    <img
                      sx={{ display: "block", float: "right" }}
                      src="/images/icons/filter-icon.svg"
                      alt="Filter Icon"
                      width="16"
                      height="16"
                    />
                  </IconButton>
                </Box>
                <Box sx={{ textAlign: "right", width: "100%", mt: "-9" }}>
                  Search &nbsp;{" "}
                  <IconButton
                    sx={{
                      border: "1px solid #CAD3E7",
                      borderRadius: "4px",
                      backgroundColor: "#f3f6f9",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowSubmitSearch((prev) => !prev);
                    }}
                    aria-label="toggle search"
                  >
                    <SearchIcon
                      sx={{
                        fontSize: 16,
                        display: "block",
                        float: "right",
                        color: "#000",
                      }}
                    />
                  </IconButton>
                </Box>
                <br />
              </Box>
            )}
            <Collapse in={submittedReportsExpanded}>
              {showSubmitFilters && (
                <Box
                  sx={{ display: "flex", gap: 2, mb: 2 }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Select
                    multiple
                    value={statusSubmitFilter}
                    onChange={(e) => {
                      e.stopPropagation(); // Prevents parent click event
                      setStatusSubmitFilter(e.target.value);
                    }}
                    displayEmpty
                    fullWidth
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return `All Statuses (${hazards.length + incidents.length + accidents.length})`; // Placeholder when nothing is selected
                      }
                      return selected.join(", "); // Display selected options as a comma-separated string
                    }}
                    sx={{ minWidth: 120 }}
                  >
                    <MenuItem value="hazard">
                      <ListItemText primary={`Hazard (${hazards.length})`} />
                      <Checkbox
                        checked={statusSubmitFilter.includes("hazard")}
                      />
                    </MenuItem>
                    <MenuItem value="incident">
                      <ListItemText
                        primary={`Incident (${incidents.length})`}
                      />
                      <Checkbox
                        checked={statusSubmitFilter.includes("incident")}
                      />
                    </MenuItem>
                    <MenuItem value="accident">
                      <ListItemText
                        primary={`Accident (${accidents.length})`}
                      />
                      <Checkbox
                        checked={statusSubmitFilter.includes("accident")}
                      />
                    </MenuItem>
                  </Select>
                </Box>
              )}
              {showSubmitSearch && (
                <Box
                  sx={{ display: "flex", gap: 2, mb: 2 }}
                  onClick={(e) => e.stopPropagation()} // Prevents parent click event
                >
                  <TextField
                    placeholder="Search"
                    variant="outlined"
                    fullWidth
                    value={searchSubmitQuery}
                    onChange={(e) => setSearchSubmitQuery(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon style={{ color: "#2D1C86" }} />{" "}
                          {/* Adjust color if needed */}
                        </InputAdornment>
                      ),
                      sx: {
                        borderRadius: "8px", // Rounded corners
                        backgroundColor: "#FFFFFF", // Background color
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)", // Shadow
                        padding: "0px 10px", // Adjust padding if necessary
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "rgba(0, 0, 0, 0.12)", // Border color
                        },
                        "&:hover fieldset": {
                          borderColor: "#2D1C86", // Border color on hover
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#2D1C86", // Border color on focus
                        },
                      },
                    }}
                  />
                </Box>
              )}
              <Tabs
                value={submittedReportsTab}
                onChange={(e, newValue) => {
                  e.stopPropagation(); // Prevents the parent click event
                  handleSubmittedReportsTabChange(e, newValue);
                }}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="false"
                sx={{
                  marginBottom: "30px",
                  "& .MuiTab-root": {
                    padding: "6.5px", // Adjust padding as needed
                    minWidth: 0, // Remove default minimum width if necessary
                  },
                  "& .MuiTab-wrapper": {
                    alignItems: "center", // Keep the content centered
                  },
                }}
              >
                <Tab
                  label={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "0.875rem",
                      }}
                    >
                      Pending
                      <br />
                      {pendings.length}
                    </span>
                  }
                  value="Pending"
                />
                <Tab
                  label={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "0.875rem",
                      }}
                    >
                      Queried
                      <br />
                      {queried.length}
                    </span>
                  }
                  value="Queried"
                />
                <Tab
                  label={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "0.875rem",
                      }}
                    >
                      Drafts
                      <br />
                      {drafts.length}
                    </span>
                  }
                  value="Draft"
                />
              </Tabs>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead sx={{ background: "#ccc" }}>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "700" }}>
                        Description
                      </TableCell>
                      <TableCell sx={{ fontWeight: "700" }}>
                        Submitted On
                      </TableCell>
                      <TableCell sx={{ fontWeight: "700" }}>Risk</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredReports.map((report, index) => (
                      <TableRow
                        key={index}
                        onClick={() => handleItemEdit(report, false)}
                      >
                        <TableCell>{report.description}</TableCell>
                        <TableCell>
                          {convertTimestampToDate(report.updatedAt ?? "")}
                        </TableCell>
                        <TableCell>{report.risk}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Collapse>
          </Paper>

          <Box sx={{ height: "20px" }} />

          <Paper
            sx={{
              backgroundColor: "#fff",
              padding: 3,
              marginBottom: "20px",
              cursor: "pointer",
            }}
            onClick={() => setInsightsExpanded(!insightsExpanded)}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                marginBottom: "30px",
                display: "flex",
                alignItems: "center",
              }}
            >
              Insights -{" "}
              <span
                style={{
                  fontSize: "1rem",
                  fontWeight: "normal",
                  marginLeft: "4px",
                }}
              >
                Reports Received
              </span>
              <IconButton
                onClick={() => setInsightsExpanded(!insightsExpanded)}
                sx={{ marginLeft: "auto" }}
              >
                {insightsExpanded ? <ExpandLess /> : <ExpandMore />}
              </IconButton>
            </Typography>
            <Collapse in={!insightsExpanded}>
              <Box onClick={(e) => e.stopPropagation()}>
                {!loading ? (
                  <Typography
                    variant="body1"
                    sx={{
                      display: "flex",
                      gap: 2,
                      color: "#333",
                      fontWeight: 400,
                    }}
                  >
                    <span
                      style={{
                        color: "#777",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevents the parent click event
                        handleInsightsHazards();
                      }}
                    >
                      Hazards:{" "}
                      <strong style={{ color: "#0056b3" }}>
                        {hazards.length}
                      </strong>
                    </span>
                    <span
                      style={{
                        color: "#777",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevents the parent click event
                        handleInsightsIncidents();
                      }}
                    >
                      Incidents:{" "}
                      <strong style={{ color: "#28a745" }}>
                        {incidents.length}
                      </strong>
                    </span>
                    <span
                      style={{
                        color: "#777",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevents the parent click event
                        handleInsightsAccidents();
                      }}
                    >
                      Accidents:{" "}
                      <strong style={{ color: "#ffc107" }}>
                        {accidents.length}
                      </strong>
                    </span>
                  </Typography>
                ) : (
                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={loading}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
                )}
              </Box>
            </Collapse>
            {insightsExpanded && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    padding: 1,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    color="success"
                    sx={{ marginRight: "10px" }} // Margin to the right for spacing
                    onClick={() => handleAnalytics()}
                  >
                    View Breakdown
                  </Button>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row", padding: 1 }}>
                  <Box sx={{ textAlign: "right", width: "100%", mt: "-9" }}>
                    Filter&nbsp;{" "}
                    <IconButton
                      sx={{
                        border: "1px solid #CAD3E7",
                        borderRadius: "4px",
                        backgroundColor: "#f3f6f9",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleFilterToggle();
                      }}
                      aria-label="toggle filters"
                    >
                      {/* Use your custom filter icon here */}
                      <img
                        sx={{ display: "block", float: "right" }}
                        src="/images/icons/filter-icon.svg"
                        alt="Filter Icon"
                        width="16"
                        height="16"
                      />
                    </IconButton>
                  </Box>
                  <Box sx={{ textAlign: "right", width: "100%", mt: "-9" }}>
                    Search &nbsp;{" "}
                    <IconButton
                      sx={{
                        border: "1px solid #CAD3E7",
                        borderRadius: "4px",
                        backgroundColor: "#f3f6f9",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowInsightSearch((prev) => !prev);
                      }}
                      aria-label="toggle search"
                    >
                      <SearchIcon
                        sx={{
                          fontSize: 16,
                          display: "block",
                          float: "right",
                          color: "#000",
                        }}
                      />
                    </IconButton>
                  </Box>

                  <br />
                </Box>
              </>
            )}
            <Collapse in={insightsExpanded}>
              {showFilters && (
                <Box
                  sx={{ display: "flex", gap: 2, mb: 2 }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Select
                    multiple
                    value={statusFilter}
                    onChange={(e) => {
                      e.stopPropagation(); // Prevents parent click event
                      setStatusFilter(e.target.value);
                    }}
                    displayEmpty
                    fullWidth
                    renderValue={(selected) => {
                      if (selected.length === 0) {
                        return "All Statuses"; // Placeholder when nothing is selected
                      }
                      return selected.join(", "); // Display selected options as a comma-separated string
                    }}
                    sx={{ minWidth: 120 }}
                  >
                    <MenuItem value="Approved">
                      <ListItemText primary={`Approved (${apporved.length})`} />
                      <Checkbox checked={statusFilter.includes("Approved")} />
                    </MenuItem>
                    <MenuItem value="Queried">
                      <ListItemText primary={`Queried (${queried.length})`} />
                      <Checkbox checked={statusFilter.includes("Queried")} />
                    </MenuItem>
                    <MenuItem value="Pending">
                      <ListItemText primary={`Pending (${pendings.length})`} />
                      <Checkbox checked={statusFilter.includes("Pending")} />
                    </MenuItem>
                  </Select>

                  <TextField
                    label="Start Date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={startDate}
                    onChange={(e) => {
                      e.stopPropagation(); // Prevents parent click event
                      setStartDate(e.target.value);
                    }}
                  />

                  <TextField
                    label="End Date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={endDate}
                    onChange={(e) => {
                      e.stopPropagation(); // Prevents parent click event
                      setEndDate(e.target.value);
                    }}
                  />
                </Box>
              )}

              {showInsightSearch && (
                <Box
                  sx={{ display: "flex", gap: 2, mb: 2 }}
                  onClick={(e) => e.stopPropagation()} // Prevents parent click event
                >
                  <TextField
                    placeholder="Search..."
                    variant="outlined"
                    fullWidth
                    value={searchInsightQuery} // This should be a state variable to hold the search input value
                    onChange={(e) => setSearchInsightQuery(e.target.value)} // Update state on change
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon style={{ color: "#2D1C86" }} />{" "}
                          {/* Adjust color if needed */}
                        </InputAdornment>
                      ),
                      sx: {
                        borderRadius: "8px", // Rounded corners
                        backgroundColor: "#FFFFFF", // Background color
                        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)", // Shadow
                        padding: "0px 10px", // Adjust padding if necessary
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "rgba(0, 0, 0, 0.12)", // Border color
                        },
                        "&:hover fieldset": {
                          borderColor: "#2D1C86", // Border color on hover
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#2D1C86", // Border color on focus
                        },
                      },
                    }}
                  />
                </Box>
              )}
              <Tabs
                value={insightsTab}
                onChange={(e, newValue) => {
                  e.stopPropagation(); // Prevents the parent click event
                  handleInsightsTabChange(e, newValue);
                }}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="false"
                sx={{
                  marginBottom: "30px",
                  "& .MuiTab-root": {
                    padding: "6px 12px", // Adjust padding as needed
                    minWidth: 0, // Remove default minimum width if necessary
                  },
                  "& .MuiTab-wrapper": {
                    alignItems: "center", // Keep the content centered
                  },
                }}
              >
                <Tab
                  label={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "0.875rem",
                      }}
                    >
                      Hazards
                      <br />
                      {hazards.length}
                    </span>
                  }
                  value="hazards"
                />
                <Tab
                  label={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "0.875rem",
                      }}
                    >
                      Incidents
                      <br />
                      {incidents.length}
                    </span>
                  }
                  value="incidents"
                />
                <Tab
                  label={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "0.875rem",
                      }}
                    >
                      Accidents
                      <br />
                      {accidents.length}
                    </span>
                  }
                  value="accidents"
                />
              </Tabs>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead sx={{ background: "#ccc" }}>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "700" }}>
                        Description
                      </TableCell>
                      <TableCell sx={{ fontWeight: "700" }}>Reporter</TableCell>
                      <TableCell sx={{ fontWeight: "700" }}>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredInsights.map((insight, index) => (
                      <TableRow
                        key={index}
                        onClick={() => handleItemEdit(insight, true)}
                      >
                        <TableCell>{insight.description}</TableCell>
                        <TableCell>
                          {insight.reporter ?? "Leonard Beadle"}
                        </TableCell>
                        <TableCell>
                          <span style={getStatusStyles(insight.status)}>
                            {insight.status}
                          </span>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Collapse>
          </Paper>

          <SnackbarAlert
            open={snackbar.open}
            onClose={handleClose}
            severity={snackbar.severity}
            message={snackbar.message}
          />
          <ConfirmModal
            open={confirmModal}
            onClose={(field, value) => {
              console.log(field, value);
              setConfirmModal(false);
              if (
                field &&
                typeof field !== "object" &&
                value !== "backdropClick"
              ) {
                handleEdit(field, value);
              } else {
                handleCancel();
              }
            }}
            title={
              selectedEdit.type === "hazard"
                ? "Confirm Hazard Request"
                : selectedEdit.type === "incident"
                  ? "Confirm Incident Request"
                  : "Confirm Accident Request"
            }
            fields={
              selectedEdit.type === "hazard"
                ? hazardRequestFields
                : selectedEdit.type === "incident"
                  ? incidentRequestFields
                  : accidentRequestFields
            }
            formData={selectedEdit}
            handleConfirm={handleSubmit}
            handleChange={handleChange}
            handleEdit={handleEdit}
            preview={true}
          />
          <AnalyticsModal
            open={openAnalyticsModal}
            onClose={setOpenAnalyticsModal}
            data={analyticsData}
            type={"Health"}
          />
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={summaryLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </Container>
      ) : (
        <Filter
          filters={filters}
          setFilters={setFilters}
          type={filterState.type}
          data={filterState.datasets}
          setFilterState={setFilterState}
        />
      )}
    </>
  );
};

export default HealthAndSafetyReview;
